import HomeIcon from '@mui/icons-material/Home';
import EventNoteIcon from '@mui/icons-material/EventNote';
import MapIcon from '@mui/icons-material/Map';
import ConstructionIcon from '@mui/icons-material/Construction';
import SecuritySharpIcon from '@mui/icons-material/SecuritySharp';
import HistoryIcon from '@mui/icons-material/History';

// The six destinations, in one place.
//
// Two surfaces render them — the header menu (desktop/tablet) and the bottom tab
// bar (phones) — and they must never drift: same icons, same order, same routes.
// Icons all come from @mui/icons-material (v5). Home used to be imported from
// @material-ui/icons (v4); it was the app's last v4 import and it dragged a
// second, duplicate icon kit into the bundle.
const NAV_DESTINATIONS = [
  { key: '/', label: 'Home', Icon: HomeIcon },
  // requiresSatellites: Navigation filters these two out of both nav surfaces on a tenant
  // with zero satellites.
  {
    key: '/Schedule',
    label: 'Schedule',
    Icon: EventNoteIcon,
    requiresSatellites: true,
    children: [
      { key: '/Schedule/Timeline', label: 'Timeline' },
      { key: '/Schedule/List', label: 'List' },
      { key: '/Schedule/RadarSimulation', label: 'Radar Simulation' },
    ],
  },
  { key: '/Map', label: 'Map', Icon: MapIcon, requiresSatellites: true },
  { key: '/Configuration', label: 'Configuration', Icon: ConstructionIcon },
  { key: '/SystemReports', label: 'System Reports', Icon: SecuritySharpIcon },
  { key: '/SystemHistory', label: 'System History', Icon: HistoryIcon },
];

// Stable, readable hook for tests and analytics: "System Reports" ->
// "system-reports".
export const slugify = (label) => label.toLowerCase().replace(/\s+/g, '-');

// A destination is current when the route *is* it or lives under it. '/' is
// exact-only — as a prefix it would match every route in the app.
export const isCurrentRoute = (key, pathname) =>
  key === '/' ? pathname === '/' : pathname === key || pathname.startsWith(`${key}/`);

export default NAV_DESTINATIONS;
